import type { Locale } from 'antd/es/locale';
import arEG from 'antd/locale/ar_EG';
import enUS from 'antd/locale/en_US';
import esES from 'antd/locale/es_ES';
import heIL from 'antd/locale/he_IL';

import { SupportedLocale } from './settings';

export const ANTD_LOCALES: Record<SupportedLocale, Locale> = {
  en: enUS,
  he: heIL,
  ar: arEG,
  es: esES,
};
